import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiPost } from '@services/service';
import { setPrimaryFormValidity } from "@store/reducers/form-contact-primary-slice";
import { RootState } from "../store";
import { POST_CREATE_CASE_LOAD, POST_PRODUCT_INFO_EDIT_CASE, POST_RetrieveContactDetailsOnChange } from '@constants/end-points';
import { EquipmentPhysicalAddress } from '@constants/case-create';
import { stat } from 'fs';


interface CaseState {
  caseInfo: any;
  contactsdata: any;
  savedContactsDropDown: any;
  countryList: any,
  countryCodes: any;
  siteSubAccount: any;
  shippingaddressdetails:any;
  IsTaxEnabledCountry:any;
  bindPin:any;
  selectedcasepriority:any;
  productInfo: any;
  loading: boolean;
  error: string | null;
}

const initialState: CaseState = {
  caseInfo: null,
  contactsdata: null,
  savedContactsDropDown: null,
  countryCodes: null,
  countryList: null,
  productInfo: null,
  selectedcasepriority:null,
  bindPin:null,
  siteSubAccount: null,
  shippingaddressdetails: null,
  IsTaxEnabledCountry:null,
  loading: false,
  error: null,
};

export const fetchCaseInfo = createAsyncThunk<
  any,
  { contactid: any; },
  { rejectValue: string }
>(
  'case/fetchCaseInfo',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiPost(POST_CREATE_CASE_LOAD, payload);
      const data: Record<string, any> = response?.data || {};
      const parsedData = Object.keys(data).reduce((acc: Record<string, any>, key: string) => {
        try {
          acc[key] = JSON.parse(data[key]);
        } catch {
          acc[key] = data[key];
        }
        return acc;
      }, {});

      return parsedData;
    } catch (error:unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue('An unknown error occurred');
    }
  }
);


export const fetchContactDetailsInfo = createAsyncThunk<
  any,
  { contactid: any; lcid: string; datalang: string },
  { rejectValue: string }
>(
  'case/fetchContactDetailsInfo',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiPost(POST_RetrieveContactDetailsOnChange, payload);
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAndProcessCaseInfo = createAsyncThunk(
  "case/fetchAndProcess",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;
    const caseInfo:any = state.createCaseAPI.caseInfo;
    if (caseInfo) {
      const contactsdata = caseInfo.Contactsdata?.[0];
      const countryValue = caseInfo.CountryList.filter((val: { Key: string }) => val.Key === contactsdata.countryId)[0];
      const primaryContactInformation = {
        ...contactsdata, 
        UserId: [contactsdata?.UserId],
        phNumCountryCode: [contactsdata?.countryId],
        phNumAlternateCountryCode: [''],
        countryId: [contactsdata?.countryId],
        PhoneNumber: contactsdata.PhoneNumber.replace(countryValue?.CountryCode, ''),
        AlternatePhoneNumber: contactsdata.AlternatePhoneNumber.replace(countryValue?.CountryCode, '')
      }
      const isValid = true;
      dispatch(setPrimaryFormValidity({ isValid, formData: primaryContactInformation }));
    }
  }
); 

const createCaseAPIs = createSlice({
  name: 'case',
  initialState,
  reducers: {
    resetState: (state) => {
      state.caseInfo = null;
      state.contactsdata = null;
      state.savedContactsDropDown = null;
      state.countryList = null;
      state.productInfo = null;
      state.countryCodes = null;
      state.selectedcasepriority = null;
      state.IsTaxEnabledCountry = null;
      state.error = null;
    },
    updateBindPin: (state, action) => {
      state.bindPin = Array.isArray(action.payload)
        ? action.payload.map(({ Value, Key }: any) => ({
            label: Value,
            value: Key,
          }))
        : [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCaseInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCaseInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.caseInfo = action.payload;
        state.contactsdata = action.payload.Contactsdata?.[0];
        state.selectedcasepriority = action.payload.selectedcasepriority.Key;
        state.savedContactsDropDown = Array.isArray(action.payload.SavedContactsDropDown)
         ? [
             ...action.payload.SavedContactsDropDown.map(({ Value, Key }: any) => ({
               label: Value,
               value: Key,
             }))
           ]
         : [];

        state.countryList = Array.isArray(action.payload.CountryList)
          ? action.payload.CountryList.map(({ Value, Key, ShortCode }: any) => ({
            label: Value,
            value: Key,
            ShortCode: ShortCode,
            CountryName: Value
          }))
          : [];

        state.countryCodes = Array.isArray(action.payload.CountryList)
          ? action.payload.CountryList.map(({ Key, CountryCode, ShortCode,Value }: any) => ({
            label: `${CountryCode} ${ShortCode}`, // Corrected
            value: Key,
            CountryCode: CountryCode,
            CountryName: Value
          }))
          : [];

          state.siteSubAccount = Array.isArray(action.payload.siteSubAccount)
          ? action.payload.siteSubAccount.map(({ Value, Key }: any) => ({
            label: Value,
            value: Key,
          }))
          : [];

          state.bindPin = Array.isArray(action.payload.bindPin)
          ? action?.payload?.bindPin?.map(({ Value, Key }: any) => ({
            label: Value,
            value: Key,
          }))
          : [];

          const contact = action.payload.Contactsdata?.[0];
          if (contact) {
            contact.UserId = [""];
            contact.FirstName = "";
            contact.LastName = "";
            contact.countryId = [""];
            contact.PhoneNumber = "";
            contact.Email = ""; 
            contact.Extension = "";
            contact.AlternatePhoneNumber="";

           if (contact.phNumCountryCode !== undefined) {
           contact.phNumCountryCode = [""];
            }
          }
          const initialData = action.payload.shippingaddressdetails?.[0]
          const siteName = state.siteSubAccount.map((items:any)=>{
            if(items.label === initialData.company){
              return items.value;
            }
            }).filter(Boolean)[0]

            const bindPin = action.payload?.bindPin;

          const updatedShippingAddress = {
            ...EquipmentPhysicalAddress,
            ...contact,
            ...action.payload.shippingaddressdetails?.[0],
            UserId: contact?.UserId ?? ["-1"],
            countryId: [action.payload.shippingaddressdetails?.[0].country],
            SiteName: [siteName],
            BindingPin: bindPin.length === 1 ? [bindPin[0].Key] : [''],
            country: [action.payload.shippingaddressdetails?.[0].country],
            EquipmentCountryName: action.payload.shippingaddressdetails?.[0].countryName
          };

        state.shippingaddressdetails = updatedShippingAddress;
        state.IsTaxEnabledCountry = action.payload.IsTaxEnabledCountry;

        state.IsTaxEnabledCountry = Array.isArray(action.payload.CountryList)
        ? action.payload.CountryList
            .map(({ Key, ShortCode }: any) =>
              action.payload.IsTaxEnabledCountry.includes(ShortCode) ? Key : null
            )
            .filter(Boolean)
        : [];


      })
      .addCase(fetchCaseInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchProductInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.productInfo = action.payload;
      })
      .addCase(fetchProductInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      
  },
});


// export const fetchProductInfo = createAsyncThunk(
//   'case/fetchProductInfo',
//   async (_, { rejectWithValue }) => {
//     try {
//       // const payload = {
//       //   ainfo: 'HU265BM18V',
//       //   pinfo: '',
//       //   pno: 'A7F65A',
//       //   contactid: '85680C15-7814-E711-80FC-5065F38AD971',
//       //   lcid: '1033',
//       //   datalang: 'en-US',
//       // };
//       const response = await apiPost(POST_PRODUCT_INFO_EDIT_CASE, payload);
//       return response?.data;
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const fetchProductInfo = createAsyncThunk<
  any,
  { contactid: any; pinfo:any, pno:any, ainfo:any },
  { rejectValue: string }
>(
  'case/fetchProductInfo',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiPost(POST_PRODUCT_INFO_EDIT_CASE, payload);
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);



export const { resetState, updateBindPin } = createCaseAPIs.actions;
export default createCaseAPIs.reducer;
